import { useSavedSessions } from "../hooks/useSavedSessions";
import { Button } from "../components/Button";
import { Link } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";
import toast from "react-hot-toast";
export default function SavedSessionsPage() {
	const { sessions, deleteSession } = useSavedSessions();

	return (
		<div className="max-w-4xl mx-auto px-4">
			<h1 className="text-3xl font-bold mb-6 flex items-center gap-2">
				📂 Saved Sessions
			</h1>

			{sessions.length === 0 ? (
				<div className="text-gray-500 text-center py-16">
					You haven’t saved any sessions yet. Try generating some names and hit 💾 Save.
				</div>
			) : (
				<div className="space-y-6">
					{sessions.map((s) => (
						<div
							key={s.id}
							className="rounded-xl border border-gray-200 bg-white shadow-sm p-6 hover:shadow-md transition"
						>
							<div className="flex justify-between items-start mb-2">
								<div>
									<div className="text-lg font-semibold text-gray-800">
										{s.keywords.join(", ")}
									</div>
									<div className="text-sm text-gray-500">
										Saved {formatDistanceToNow(new Date(s.createdAt))} ago
									</div>
								</div>

								<Button
									variant="danger"
									onClick={() => deleteSession(s.id)}
								>
									🗑 Delete
								</Button>
							</div>

							<div className="text-sm text-gray-600 italic line-clamp-2">
								{s.results.slice(0, 5).map((r) => r.name).join(", ")}...
							</div>

							<div className="flex flex-wrap items-center gap-2 text-sm text-gray-600 mt-3">
								<Badge icon="🎛" label={s.tone} />
								<Badge icon="📏" label={s.length} />
								<Badge icon="🌐" label={s.tlds?.join(', ') ?? ''} />
							</div>

							<div className="mt-4">
								<Link to={`/app?sid=${s.id}`}>
									<Button variant="outline">
										🔄 Load Session
									</Button>
								</Link>
								<Link to={`/share/${s.id}`}>
									<Button
										variant="outline"
										size="md"
										title="Copy link to share this session"
										onClick={() => {
											const shareUrl = `${window.location.origin}/share/${s.id}`;
											navigator.clipboard.writeText(shareUrl);
											toast.success("Shareable link copied to clipboard!");
										}}
									>
										🔗 Share
									</Button>
								</Link>
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	);
}

function Badge({ icon, label }: { icon: string; label: string }) {
	return (
		<span className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 px-2 py-1 rounded-full text-xs font-medium">
			<span>{icon}</span> {label}
		</span>
	);
}
